/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye-background': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#813CCF" fill-rule="evenodd"><circle pid="0" fill-opacity=".1" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M16 10c5.444 0 9 5.5 9 5.5S21.444 21 16 21s-9-5.5-9-5.5 3.556-5.5 9-5.5zm0 1.571c2.21 0 4 1.758 4 3.929 0 2.17-1.79 3.929-4 3.929s-4-1.758-4-3.929c0-2.17 1.79-3.929 4-3.929zm0 1.768c1.216 0 2.2.967 2.2 2.161s-.984 2.16-2.2 2.16c-1.214 0-2.2-.966-2.2-2.16 0-1.194.984-2.16 2.2-2.16z"/></g>'
  }
})
